export default function CharterHero() {
  const scrollToSearch = () => {
    const searchSection = document.getElementById('charter-search');
    if (searchSection) {
      const yOffset = -80; // Offset for fixed navigation
      const y = searchSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/811349f137f3cd62701ef10c93d38df6.jpeg"
          alt="Luxury Yacht Charter"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>
      
      <div className="relative z-10 text-center px-8 max-w-5xl w-full">
        <div className="w-20 h-px bg-white mx-auto mb-8"></div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-8 leading-tight">
          Luxury Yacht Charter
        </h1>
        <p className="text-xl md:text-2xl text-white/90 leading-relaxed mb-12 max-w-3xl mx-auto">
          Curated charter experiences aboard the world's finest yachts, tailored to your destination, preferences, and lifestyle.
        </p>
        <button 
          onClick={scrollToSearch}
          className="px-12 py-4 bg-white text-black text-base font-medium hover:bg-gray-100 transition-colors whitespace-nowrap"
        >
          Explore Available Charters
        </button>
      </div>
    </section>
  );
}
